module.exports = __webpack_public_path__ + "static/mask-ba70004f5ee73701ac681d7c5513e947.png";